import React from 'react';
import * as S from './ShopSkeleton.styles';

export const ShopAdsSkeleton: React.FC = () => {
  return (
    <S.SkeletonWrapper>
      <S.SkeletonBottom>
        <S.SkeletonLineGroup>
          <S.SkeletonLine $width="150px" $height="40px" />
          <S.SkeletonLine $width="150px" $height="40px" />
          <S.SkeletonLine $width="150px" $height="40px" />
          <S.SkeletonLine $width="150px" $height="40px" />
        </S.SkeletonLineGroup>
        <S.SkeletonCardGrid>
          {Array.from({ length: 10 }).map((_, i) => (
            <div key={i} />
          ))}
        </S.SkeletonCardGrid>
      </S.SkeletonBottom>
    </S.SkeletonWrapper>
  );
};
